import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { GetRegistrationDataRequestParams } from 'src/generated-sources/openapi/alert-service/registration-data';
import { RegistrationDataService } from 'src/generated-sources/openapi/alert-service/registration-data/api/registration-data.service';
import { PartnerShareholdingResponseDto } from 'src/generated-sources/openapi/alert-service/registration-data/model/partner-shareholding-response';
import { RegistrationAttributeResponseDto } from 'src/generated-sources/openapi/alert-service/registration-data/model/registration-attribute-response';
import { PartnersShareholdingRequestDto } from 'src/generated-sources/openapi/alert-service/registration-data/model/partners-shareholding-request';
import { PartnersRegistrationDataRequestDto } from 'src/generated-sources/openapi/alert-service/registration-data/model/partners-registration-data-request';
import { PartnersRegistrationDataResponseDto } from 'src/generated-sources/openapi/alert-service/registration-data/model/partners-registration-data-response';

export interface RegistrationDataRequest extends GetRegistrationDataRequestParams {}

@Injectable()
export class RegistrationDataLoaderService {
  private readonly registrationDataService = inject(RegistrationDataService);

  loadRegistrationData(
    request: RegistrationDataRequest,
  ): Observable<RegistrationAttributeResponseDto[]> {
    return this.registrationDataService
      .getRegistrationData({
        walletId: request.walletId,
        registryId: request.registryId,
        type: request.type,
      })
      .pipe(
        map((response) => response || []),
        catchError((error) => {
          console.error('Error loading registration data:', error);
          return of([]);
        }),
      );
  }

  loadPartnersShareholding(
    request: PartnersShareholdingRequestDto,
  ): Observable<PartnerShareholdingResponseDto[]> {
    return this.registrationDataService
      .getPartnersShareholding({ partnersShareholdingRequestDto: request })
      .pipe(map((response) => response || []));
  }

  loadPartnersRegistrationData(
    request: PartnersRegistrationDataRequestDto,
  ): Observable<PartnersRegistrationDataResponseDto[]> {
    return this.registrationDataService
      .getPartnersRegistrationData({ partnersRegistrationDataRequestDto: request })
      .pipe(map((response) => response || []));
  }
}
